<div class="groupHeader1">
    <ng-container *ngIf="favouriteId == 0">
        <div class="groupHeader1-title">Search Results</div>
    </ng-container>

    <!-- <ng-container *ngIf="favouriteId > 0">
        <div class="groupHeader1-title">{{favouriteName}}</div>
    </ng-container> -->

    <!-- <mat-radio-group [(ngModel)]="defaultView" ngDefaultControl>
        <mat-radio-button [value]="1" labelPosition="after">
            <div style="display:flex">
                <div>Cracks</div>
                <div *ngIf="hasCracks==true">
                    <i class="material-icons button__icon"
                        style="font-size: 10px; margin-left: 10px; color: red">lens</i>
                </div>
            </div>
        </mat-radio-button>
        <mat-radio-button [value]="2" labelPosition="after">Eval Code</mat-radio-button>
        <mat-radio-button [value]="3" labelPosition="after">Percent Worn</mat-radio-button>
    </mat-radio-group> -->
    <!-- <div *ngIf="favouriteId>0">
        <a class="button" (click)="OpenFavourite()" title="Edit Favourite"
            style="margin-left: 120px; min-width: 60px; padding: 6px 6px">
            <i class="material-icons button__icon">edit</i>
            <span class="button__text"></span>
        </a>
    </div> -->
</div>
<div class="table-container mat-elevation-z8">
    <div style="margin-left: 39%;" *ngIf="loading && EquipmentdetailsList==null && ImplementypesList==null">
        <mat-spinner> </mat-spinner>
    </div>
    <!-- <mat-table  *ngIf="!loading" #equipmentImplementsTable [dataSource]="dataSource" [@fadeInOut]
               class="table-material table-material--striped table-material--hover table-material--full-width">

        <ng-container *ngFor="let col of columns">
            <ng-container matColumnDef="{{col.columnDef}}">
                <mat-header-cell *matHeaderCellDef >{{col.header}}</mat-header-cell>
                <mat-cell *matCellDef="let row; let i = index" (click)="openEquipmentDetails(detailsArrayEquipment[i])" style="cursor: pointer;">

                    <ng-container *ngIf="col.isCore==0">
                        <ng-container *ngFor="let implement of detailsArray[i][col.item]">
                            <div [class]="getEvalClass(implement)" title="{{implement.ImplementName}}">
                                {{displayEval(implement)}}
                            </div>
                        </ng-container>
                    </ng-container>

                    <ng-container *ngIf="col.isCore==1">
                        <div>
                            {{col.cell(detailsArray[i], col.item)}}
                        </div>
                    </ng-container>

                </mat-cell>
            </ng-container>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </mat-table> -->

    <div *ngIf="EquipmentdetailsList!=null">


        <table id="table_detail" cellpadding=10 class="table table--full-width table--striped">

            <tr>
                <th>Serial Number </th>
                <th>Unit Number </th>
                <th>Model </th>
                <th>Job Site </th>
                <th>SMU (hrs) </th>
                <th>Last Inspection </th>
                <th></th>

            </tr>
            <ng-container *ngFor="let eq of EquipmentdetailsList.Details">
                <tr style="cursor: pointer;">

                    <td (click)="openDFIImplmentDetails(eq.EquipmentId)">{{eq.serialNo}}</td>
                    <td (click)="openDFIImplmentDetails(eq.EquipmentId)"> {{eq.unitNo}}</td>
                    <td (click)="openDFIImplmentDetails(eq.EquipmentId)">{{eq.modelDesc}}</td>
                    <td (click)="openDFIImplmentDetails(eq.EquipmentId)">{{eq.siteName}}</td>
                    <td (click)="openDFIImplmentDetails(eq.EquipmentId)">{{eq.currentSMU}}</td>
                    <td (click)="openDFIImplmentDetails(eq.EquipmentId)">{{eq.lastInspectionDate}}</td>
                    <td>
                        <i style="cursor: pointer;" *ngIf="eq.IsExapand" class="material-icons ttmodal__close-button"
                            (click)="ChangeExpand(eq)" matTooltip="Show Less">expand_less</i>
                        <i style="cursor: pointer;" *ngIf="!eq.IsExapand" class="material-icons ttmodal__close-button"
                            (click)="ChangeExpand(eq)" matTooltip="Show More">expand_more</i>
                    </td>


                </tr>
                <tr>
                    <td colspan=7>
                        <table class="table table--full-width table--striped" *ngIf="eq.IsExapand"
                            style="margin-left: 2%;">
                            <thead>
                                <tr>
                                    <th  style="padding: 0px 24px;width: 32%;">System </th>
                                    <th style="padding: 0px 24px;width: 10%;">System Condition</th>
                                    <th style="padding: 0px 24px;width: 10%;;text-align: center;">No of Cracks </th>
                                    <th></th>

                                </tr>
                            </thead>
                            <tbody>
                                <ng-container *ngFor="let imp of ImplementypesList">
                                    <tr *ngIf="eq.EquipmentId == imp.EquipmentId">
                                        <td (click)="openDFIImplmentDetails(eq.EquipmentId)">{{imp.Name}}</td>
                                        <td><span class="Eval-{{ imp.WorstWorn | wornPercentageToEval}}"
                                                style="margin-right: 7px;padding: 7px 21px;">
                                                <div>{{imp.WorstWorn?.toFixed(1)}}%</div>
                                            </span></td>
                                        <td><span class="Eval-{{ imp.WorstWorn | wornPercentageToEval}}"
                                                style="margin-right: 7px;padding: 7px 21px;">
                                                <div>{{imp.CrackCount}}/ {{imp.ObsCount}}</div>
                                            </span></td>
                                        <td *ngIf="imp.HasComponents">
                                            <i style="cursor: pointer;" *ngIf="imp.IsExapand"
                                                class="material-icons ttmodal__close-button"
                                                (click)="ChangeExpandImp(imp)" matTooltip="Show Less">expand_less</i>
                                            <i style="cursor: pointer;" *ngIf="!imp.IsExapand"
                                                class="material-icons ttmodal__close-button"
                                                (click)="ChangeExpandImp(imp)" matTooltip="Show More">expand_more</i>
                                        </td>

                                    </tr>

                                    <tr *ngIf="imp.HasComponents && eq.EquipmentId == imp.EquipmentId">
                                        <td colspan=4>
                                            <table class="table table--full-width table--striped" *ngIf="imp.IsExpand"
                                                style="margin-left: 2%;">
                                                <thead>
                                                    <tr>
                                                        <th style="padding: 0px 24px">Component </th>
                                                        <th style="padding: 0px 24px;width: 10%;text-align: center;">Worn %</th>
                                                        <!-- <th style="padding: 0px 24px;width: 10%;text-align: center;">Average </th> -->
                                                        <th style="padding: 0px 24px;text-align: center;">CMU </th>
                                                        <th style="padding: 0px 24px;text-align: center;">Residual </th>
                                                        <th style="padding: 0px 24px;text-align: center;">Projected </th>


                                                        <th></th>

                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <ng-container *ngFor="let comp of imp.Components">
                                                        <tr style="cursor: pointer;"
                                                            (click)="OpenComponentHistroy(comp.ComponentId,imp.Name)">
                                                            <td>{{comp.CompTypeName}} - {{comp.CompName}}</td>
                                                            <td><span class="Eval-{{ comp.Worn | wornPercentageToEval}}"
                                                                    style="margin-right: 7px;padding: 7px 21px;">
                                                                    <div>{{comp.Worn?.toFixed(1)}}%</div>
                                                                </span></td>
                                                            <!-- <td *ngIf="comp.Avg==-999"><span class="Eval-U"
                                                                    style="margin-right: 7px;padding: 7px 21px;">
                                                                    <div>N/A</div>
                                                                </span></td>
                                                            <td *ngIf="comp.Avg!=-999"><span
                                                                    class="Eval-{{ comp.Worn | wornPercentageToEval}}"
                                                                    style="margin-right: 7px;padding: 7px 21px;">
                                                                    <div>{{comp.Avg.toFixed(2)}}</div>
                                                                </span>
                                                            </td> -->

                                                            <td style="text-align: center;">{{comp.CMU}}</td>
                                                            <td  style="text-align: center;">{{comp.Residual}}</td>
                                                            <td  style="text-align: center;">{{getProjected(comp.CMU,comp.Residual)}}</td>
                                                        </tr>
                                                    </ng-container>
                                                </tbody>

                                            </table>
                                        </td>
                                    </tr>
                                </ng-container>
                            </tbody>

                        </table>
                    </td>

                </tr>
            </ng-container>




        </table>

        <!-- <table class="table table--full-width table--striped">
            <thead>
                <tr>
                    <th>Serial Number </th>
                    <th>Unit Number </th>
                    <th>Model </th>
                    <th>Job Site </th>
                    <th>SMU (hrs) </th>
                    <th>Last Inspection </th>
                    <th>Click</th>

                </tr>
            </thead>
            <ng-container *ngFor="let eq of EquipmentdetailsList.Details">
                
                <tbody>
                    <tr>
                        <td>{{eq.serialNo}}</td>
                        <td>{{eq.unitNo}}</td>
                        <td>{{eq.modelDesc}}</td>
                        <td>{{eq.siteName}}</td>
                        <td>{{eq.currentSMU}}</td>
                        <td>{{eq.lastInspectionDate}}</td>
                        <td (click)="ChangeExpand(eq)">{{eq.IsExapand}}</td>

                    </tr>

                <div *ngIf="eq.IsExapand">
  

                    <table class="table table--full-width table--striped">
                        <thead>
                            <tr>
                                <th>System </th>
                                <th>System Condition</th>
                                <th>No of Cracks </th>

                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngFor="let imp of ImplementypesList">
                                <tr *ngIf="eq.EquipmentId == imp.EquipmentId">
                                    <td>{{imp.Name}}</td>
                                    <td>60%</td>
                                    <td>0/20</td>


                                </tr>
                            </ng-container>
                        </tbody>

                    </table>
                </td>
                </div>

            </tbody>
            </ng-container>


            <ng-container>

            </ng-container>
        </table> -->
    </div>

    <!--<mat-paginator #paginator [pageSize]="10" [pageSizeOptions]="[10, 20, 50, 100]" [showFirstLastButtons]="true"></mat-paginator>-->
</div>